import { render, staticRenderFns } from "./audit-item-details-field-value.component.vue?vue&type=template&id=20ae7424"
import script from "./audit-item-details-field-value.component.vue?vue&type=script&lang=ts"
export * from "./audit-item-details-field-value.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports